var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.492 1.128.124.303h-5.9l.124-.303A1.83 1.83 0 0 1 5.535 0h2.263c.745 0 1.416.446 1.694 1.128m-8.383 1.16h11.115c.929 0 1.445 1.059.864 1.774l-.333.41c-.269.33-.415.742-.415 1.167v7.504C12.34 14.72 11.04 16 9.44 16H3.893c-1.602 0-2.9-1.28-2.9-2.857V5.638c0-.424-.147-.836-.416-1.167l-.332-.41c-.58-.714-.064-1.772.864-1.772m3.595 10.995c.288 0 .522-.23.522-.514V5.762a.52.52 0 0 0-.522-.515.52.52 0 0 0-.522.515v7.007c0 .284.234.514.522.514m3.925 0c.289 0 .522-.23.522-.514V5.762a.52.52 0 0 0-.522-.515.52.52 0 0 0-.522.515v7.007c0 .284.234.514.522.514",
    clipRule: "evenodd"
  })));
};
export default SvgBin;